import React, { useState } from "react";
import VisibleColumnToggler from "../../../helper/visibleColumnToggler";
import { SearchTagRefresh, Tooltip } from "../../../core";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

export default function ArchiveHeader(props) {
  const [showSearchBoxForMobile, setShowSearchBoxForMobile] = useState(false);
  return (
    <div className="d-flex mt-3 mb-3 contentHeader">
      {props.selectedContentsLen > 0 && (
        <div className="d-flex">
          {" "}
          <Tooltip
            item={
              <div>
                <div
                  role="presentation"
                  className="iconButton fas fa-history"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    props.handleUnArchiveItems();
                  }}
                />
              </div>
            }
            tooltipContent="Restore"
            id="unarchive-content"
          />
          <Tooltip
            item={
              <div>
                <div
                  role="presentation"
                  className="iconButton fa fa-trash"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    props.handleDeleteConfirmation();
                  }}
                />
              </div>
            }
            tooltipContent="Delete"
            id="delete-archive-content"
          />
        </div>
      )}
      <div className="ml-auto">
        <div className="d-flex">
          <PhoneBreakpoint>
            <div
              role="presentation"
              className="ml-2 contentHeader__searchContainer"
              onClick={() => {
                setShowSearchBoxForMobile(!showSearchBoxForMobile);
              }}
            >
              <i className=" bx bx-search bx-sm " />
            </div>
          </PhoneBreakpoint>
          <div
            className={`searchContaainerForMobile ${showSearchBoxForMobile &&
              "expandedSearch"}`}
          >
            <SearchTagRefresh
              ref={props.searchRef}
              handleSearch={props.handleSearch}
              {...props}
            />
            <PhoneBreakpoint>
              <div
                className="closeSearchContainer"
                onClick={() => {
                  setShowSearchBoxForMobile(!showSearchBoxForMobile);
                }}
              >
                <i className="mr-0 fa fa-times " />
              </div>
            </PhoneBreakpoint>
          </div>
          <VisibleColumnToggler
            hiddenColumns={props.hiddenColumns}
            toggleHiddenColumns={props.toggleHiddenColumns}
            columnToggleProps={props.columnToggleProps}
          />
        </div>
      </div>
    </div>
  );
}
